import { render, staticRenderFns } from "./FileOutputDocument.vue?vue&type=template&id=536a4bfa"
import script from "./FileOutputDocument.vue?vue&type=script&lang=js"
export * from "./FileOutputDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports